import React from 'react';
import { View, Text } from 'react-native';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import { LineIndicator } from 'LocalGluons';
import styles from './FreeSpaceIndicator.jss';

const FreeSpaceIndicator = ({ usedSpace }) => {
    const roundedEmptySpace = Math.ceil(100 - usedSpace);
    return (
        <View style={styles.freeSpaceContainer}>
            <LineIndicator style={styles.freeSpaceProgreesbar} progress={usedSpace} />
            <Text style={styles.freeSpaceText}>{`${t(
                'COMMON.FREE_SPACE'
            )}: ${roundedEmptySpace}%`}</Text>
        </View>
    );
};

FreeSpaceIndicator.propTypes = {
    usedSpace: PropTypes.number.isRequired
};

export default FreeSpaceIndicator;
